import { EpisodePath } from "../common/episode";
import { SheetCategory } from "../common/sheet";
import { DocumentReference, DocumentSnapshot } from "@atgof-firebase/types";
import { useSnapshot } from "./useSnapshot";
import _ from "lodash";
import { ApplicandKind, onAvailableApplicands } from "../common/applicand";

export function useAvailableApplicands(
  applicandKind: ApplicandKind,
  applicandSubjectRef: DocumentReference | undefined,
  episodePaths: EpisodePath[],
  categories: SheetCategory[],
) {
  return useSnapshot<DocumentSnapshot[] | undefined>(
    _.curry(onAvailableApplicands)(
      applicandKind,
      applicandSubjectRef,
      episodePaths,
      categories,
    ),
    [
      applicandKind,
      applicandSubjectRef?.path,
      episodePaths
        .map(({ project, episode, season }) =>
          [project, episode, season].join("/"),
        )
        .sort()
        .join("\n"),
      categories.sort().join("\n"),
    ],
  );
}
